module.exports = __webpack_public_path__ + "static/media/Fortune Teller.f3ea240a.jpg";